<template>
  <div v-if="open" class="window-open-component"
       :style="windowStyle">
    <slot />
  </div>
</template>

<script>
import {RoomUser} from '@/core/api/room.user.api';
import {debounce} from "lodash";

function copyStyles(sourceDoc, targetDoc) {
  Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
    try {
      if (styleSheet.cssRules) {
        const newStyleEl = sourceDoc.createElement("style");
        Array.from(styleSheet.cssRules).forEach((cssRule) => newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText)));
        targetDoc.head.appendChild(newStyleEl);
      } else if (styleSheet.href) {
        const newLinkEl = sourceDoc.createElement("link");

        newLinkEl.rel = "stylesheet";
        newLinkEl.href = styleSheet.href;
        targetDoc.head.appendChild(newLinkEl);
      }
      // eslint-disable-next-line no-empty
    } catch (ignore) {}
  });
}

export default {
  name: 'RoomRoomWindowOpen',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 'auto'
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    minWidth: {
      type: Number,
      default: 0
    },
    minHeight: {
      type: Number,
      default: 0
    },
    background: {
      type: String,
      default: 'linear-gradient(170deg, #0a0a15, #545f6f)'
    },
  },
  data() {
    return {
      windowRef: null,
      open: false,
    }
  },
  computed: {
    windowStyle() {
      return {
        background: this.background,
      }
    },
  },
  mounted() {
    if (this.open) {
      this.openWindow();
    }
  },
  beforeDestroy() {
    if (this.windowRef) {
      this.closeWindow();
    }
  },
  methods: {
    toggle() {
      if (!this.open) {
        this.openWindow()
      } else {
        this.closeWindow()
      }
    },
    openWindow() {
      if (!RoomUser?.isDesktop()) {
        console.warn('cannot open a new window on mobile device.')
        return;
      }
      let windowRef = this.windowRef;
      if (windowRef) {
        return windowRef;
      }
      
      let features = `menubar=no, width=${this.width}, height=${this.height}`;
      const queryString = window.location.search; // TODO 인프라 변경에 따라 추후 작업 가능서 있음
      windowRef = this.windowRef = this.getDefaultView().open('/r-v3/room/common/popup' + queryString, `_blank`, features);
      if (!windowRef) {
        alert(this.$t('room.popup'));
        return;
      }

      const layerId = 'grm_popup_' + Date.now();
      const layer = document.createElement('div');
      layer.id = layerId;
      Object.assign(layer.style, {
          'position': 'absolute',
          'zIndex': '9999999',
          'left': '0px', 'top': '0px',
          'width': '100%', 'height': '100%',
          'backgroundColor': '#000'
      });
      windowRef.addEventListener('DOMContentLoaded', e => {
        (() => {
          const base = document.createElement('base');
          base.href = '//'+location.host+'/';
          windowRef.document.head.insertBefore(base, windowRef.document.head.firstElementChild)
        })();
          windowRef.document.body.append(layer);
      }, {once: true});

      windowRef.addEventListener('load', this.initPopup.bind(this), {once: true});
      windowRef.addEventListener('load', e => {
          layer.remove();
      }, {once: true});
    },
    initPopup(){
        let windowRef = this.windowRef;
        windowRef.document.title = this.title;
        copyStyles(window.document, this.windowRef.document);
        windowRef.addEventListener('beforeunload', this.closeWindow.bind(this));
        // windowRef.addEventListener('resize', this.resizeToMinimum.bind(this, this.minWidth, this.minHeight));
        windowRef.document.body.appendChild(this.$el);
        this.open = true;
    },
    resizeToMinimum(w, h){
      const windowRef = this.windowRef;      
      w = w > windowRef.outerWidth ? w : windowRef.outerWidth;
      h = h > windowRef.outerHeight? h : windowRef.outerHeight;
      this.windowRef?.resizeTo(w, h);
    },
    closeWindow: debounce(function() {
      if (this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
        this.open = false;
        this.$emit('close');
      }
    }, 1000, {
      leading: true,
      trailing: false,
    }),
  },
}
</script>

<style lang="scss" scoped>
.window-open-component {
  position: absolute;
  inset: 0;
}
</style>